<template>
  <div class="steps">
    <a-steps direction="vertical">
      <!-- <a-step status="process">
        <template slot="title">
          <a-page-header
            style="padding: 0px 0px 10px 0px;"
            title="选择模型"
          />
        </template>
        <template slot="description">
          <a-select default-value="GPT3.5" style="width: 300px; margin: 8px;" size="large" v-model="model">
            <a-select-option value="GPT3.5">
              GPT-3.5
            </a-select-option>
          </a-select>
        </template>
      </a-step> -->
      <a-step status="process">
        <template slot="title">
          <a-page-header
            style="padding: 0px 0px 10px 0px;"
            title="修改设定"
          />
        </template>
        <template slot="description">
          <p style="font-size:16px;color:#000000;">1、点击左侧对应窗口的设置按钮，可设置部分参数</p>
          <p style="font-size:16px;color:#000000;">2、具体设置请自行查看设置界面及里面的帮助信息</p>
        </template>
      </a-step>
      <a-step status="process">
        <template slot="title">
          <a-page-header
            style="padding: 0px 0px 10px 0px;"
            title="注意事项"
          />
        </template>
        <template slot="description">
          <p style="font-size:16px;width:500px;text-align:justify;line-height:1.8;color:#000000;">1、请尽量不要输入超过1000个字。AI具有学习能力, 能够记住之前说的话, 在默认设置下能记得500个左右汉字, 可通过设置中的上下文数量调整。增大上下文数量能够增加AI的记忆力, 但可能会导致AI的回复文字变少或答非所问, 遇到上述情况时可将上下文数量设为0。</p>
          <p style="font-size:16px;color:#000000;">2、偶尔可能生成不正确、有害或有偏见的内容</p>
          <p style="font-size:16px;color:#000000;">3、对2021年后的世界和事件了解有限</p>
          <p style="font-size:16px;color:#000000;">4、不正当的请求可能会被拒绝</p>
          <p style="font-size:16px;color:#000000;">5、必须保持Hiplot正常登录状态方可使用</p>
        </template>
      </a-step>
      <a-step status="process">
        <template slot="title">
          <a-page-header
            style="padding: 0px 0px 10px 0px;"
            title="开始提问"
          />
        </template>
        <template slot="description">
          <div class="example" @click="exampleChat('用R语言写一份绘制热图的代码')">
            <a-row>
              <a-col :span="23">
                <p style="font-size:16px;color:#000000;">用R语言写一份绘制热图的代码</p>
              </a-col>
              <a-col :span="1">
                <a-icon style="font-size:16px;padding-top:3px;" type="right-circle" />
              </a-col>
            </a-row>
          </div>
          <div class="example" @click="exampleChat('评价Plos One')">
            <a-row>
              <a-col :span="23">
                <p style="font-size:16px;color:#000000;">评价Plos One</p>
              </a-col>
              <a-col :span="1">
                <a-icon style="font-size:16px;padding-top:3px;" type="right-circle" />
              </a-col>
            </a-row>
          </div>
          <div class="example" @click="exampleChat('评价Hiplot网站')">
            <a-row>
              <a-col :span="23">
                <p style="font-size:16px;color:#000000;">评价Hiplot网站</p>
              </a-col>
              <a-col :span="1">
                <a-icon style="font-size:16px;padding-top:3px;" type="right-circle" />
              </a-col>
            </a-row>
          </div>
          <div  style="height:60px;"></div>
        </template>
      </a-step>
    </a-steps>
  </div>
</template>

<script>
export default {
  name: 'ChatInit',
  props: {
    loading: Boolean
  },
  data() {
    return {
      model: 'GPT3.5'
    }
  },
  methods: {
    exampleChat(data) {
      if (!this.loading) {
        this.$emit('emitSubmit',data)
      }
    }
  }
}
</script>

<style scoped>

.steps {
  padding-top: 20px;
  padding-left: calc(100% / 2 - 300px);
}

.content {
  text-align: center;
  margin: 0 auto;
}

.example {
  height:50px;
  margin:10px 5px 10px 5px;
  border-radius: 6px;
  padding: 13px;
  cursor: pointer;
  background: rgb(230, 230, 240);
  width: 360px;
}

.example:hover {
  height:50px;
  margin:10px 5px 10px 5px;
  background: rgba(200, 200, 200, 0.2);
  border-radius: 6px;
  cursor: pointer;
  padding: 13px;
}

</style>
